import {Box, Typography} from '@mui/material';
import {CampaignDetails, Theme} from '../../types';
import {useGetCampaignFaq, useGetCampaignSupport} from '../../queries/helpQueries';

import Category from '../help/Category';
import {Colors} from '../common/colors';
import {EmailWasSentMessage} from '../common/supportMailSent';
import dynamic from 'next/dynamic';
import {useResponsive} from '../../provider/MediaQueryProvider';
import {useState} from 'react';
import {useTranslation} from 'next-i18next';

const SupportForm = dynamic(() => import('../help/SupportForm'));

type HelpProps = {
    data: CampaignDetails;
    campaignId: string;
    theme: Theme;
};

export default function Help(props: HelpProps) {
    const {t} = useTranslation('common');
    const {isMobile, isTablet} = useResponsive();
    const [wasSent, setWasSent] = useState(false);
    const margin = isTablet || isMobile ? '50px' : '100px';
    const {data: faq} = useGetCampaignFaq(props.campaignId);
    const {data: support} = useGetCampaignSupport(props.campaignId);

    if (!faq) {
        return <></>;
    }

    if (!support) {
        return <></>;
    }

    const bgColor = props.theme?.background_color ?? Colors.first;
    const emailPro = props.data?.email_pro;
    const hasEmailPro = Boolean(emailPro) && emailPro != '';

    return (
        <>
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="center"
                marginTop={margin}
                marginBottom={margin}
                marginLeft="10px"
                marginRight="10px"
            >
                <Typography
                    color={bgColor}
                    textTransform="uppercase"
                    alignSelf="center"
                    fontWeight="bold"
                    fontSize="18px"
                    textAlign="center"
                >
                    {t('title.faq_2')}
                </Typography>
            </Box>
            <Box>
                {faq.map((c) => (
                    <Category category={c} key={c.faq_category_id} />
                ))}
            </Box>
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="center"
                marginTop={margin}
                marginBottom={margin}
                marginLeft="10px"
                marginRight="10px"
            >
                <Typography
                    color={bgColor}
                    textTransform="uppercase"
                    alignSelf="center"
                    fontWeight="bold"
                    fontSize="18px"
                    textAlign="center"
                >
                    {t('tips.faq_2')}
                </Typography>
            </Box>
            {!wasSent && (
                <SupportForm
                    categories={support}
                    campaignId={props.campaignId}
                    theme={props.theme}
                    onSubmitted={() => setWasSent(true)}
                />
            )}
            {wasSent && <EmailWasSentMessage theme={props.theme} />}
            {hasEmailPro && (
                <>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        marginTop={margin}
                        marginBottom="20px"
                        marginLeft="10px"
                        marginRight="10px"
                    >
                        <Typography
                            color={bgColor}
                            textTransform="uppercase"
                            alignSelf="center"
                            fontWeight="bold"
                            fontSize="18px"
                            textAlign="center"
                        >
                            {t('tips.faq_3')}
                        </Typography>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        marginTop="20px"
                        marginBottom={margin}
                        marginLeft="10px"
                        marginRight="10px"
                    >
                        <Typography
                            color={bgColor}
                            textTransform="uppercase"
                            alignSelf="center"
                            fontWeight="bold"
                            fontSize="16px"
                            textAlign="center"
                        >
                            {t('tips.faq_4')}
                        </Typography>
                        <Box display="flex" flexDirection="row" justifyContent="center">
                            <Typography fontWeight="bold" fontSize="14px">
                                {emailPro}
                            </Typography>
                        </Box>
                    </Box>
                </>
            )}
        </>
    );
}
